// pdfjs-dist v5 uses Promise.try() which is not yet available in all browsers
if (!("try" in Promise)) {
  (Promise as any)["try"] = function <T>(fn: (...args: any[]) => T, ...args: any[]): Promise<T> {
    return new Promise<T>((resolve) => resolve(fn(...args)));
  };
}
